// extracted by mini-css-extract-plugin
export default {"metricsWrapper":"IraUserOpenOrders_metricsWrapper__vZZ5a"};